import { clearEntraParamsFromUrl, exchangeEntraCode, getEntraProfileFromTokens } from '@/auth/entraConfig'
import { useAuthStore } from '@/store/authStore'

/**
 * If Entra redirected here with ?code=..., exchange it for tokens and strip auth params from the URL.
 */
export const handleEntraRedirect = async (): Promise<void> => {
  const params = new URLSearchParams(window.location.search)
  const code = params.get('code')
  const error = params.get('error')
  const errorDescription = params.get('error_description')

  if (!code && !error) {
    return
  }

  try {
    if (error) {
      throw new Error(errorDescription || error)
    }

    if (code) {
      const tokens = await exchangeEntraCode(code)
      const profile = getEntraProfileFromTokens(tokens)
      useAuthStore.getState().completeEntraLogin({
        accessToken: tokens.access_token,
        userName: profile.userName,
        email: profile.email,
      })
    }
  } catch (err) {
    console.error('[Entra] Failed to complete redirect', err)
  } finally {
    clearEntraParamsFromUrl()
  }
}
